export default __webpack_public_path__ + "static/media/Community.b01c5c99.png";